var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_3586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 15.75V5.25C24 2.493 21.757 0.25 19 0.25H5C2.243 0.25 0 2.493 0 5.25V15.75C0 18.507 2.243 20.75 5 20.75H19C21.757 20.75 24 18.507 24 15.75ZM19 2.25C20.654 2.25 22 3.596 22 5.25V15.75C22 17.404 20.654 18.75 19 18.75H5C3.346 18.75 2 17.404 2 15.75V5.25C2 3.596 3.346 2.25 5 2.25H12H19Z",
    fill: "#4A5565"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 20.75,
    width: 2,
    height: 2,
    fill: "#4A5565"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 22.75,
    width: 12,
    height: 1,
    rx: 0.5,
    fill: "#4A5565"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_3586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.02d7275ccd0ebebb6c61901bcaf91e63.svg";
export { ForwardRef as ReactComponent };